<div fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="start center" mat-dialog-title>
    <div class="headline m-0 pb-1" fxFlex="auto" fxLayoutAlign="start center">
      <h2 class="pr-1">Cancel Deployment?</h2>
    </div>
    <button type="button" (click)="onDismiss()" mat-icon-button class="text-secondary">
      <mat-icon [icIcon]="icClose"></mat-icon>
    </button>
  </div>
  <mat-divider class="-mx-6 text-border"></mat-divider>
  <div class="overflow-auto" fxLayout="column" class="mb-4">
    <div fxLayout="row" fxLayoutAlign="start center">
      <div fxLayout="column">
        <blockquote class="blockquote-error m-0 mt-4">
          <p>
            This will stop the current deployment and discard all pending changes. No new
            configuration will be applied to the device, and the existing deployed state will remain
            unchanged.
          </p>
        </blockquote>
      </div>
    </div>
  </div>
  <mat-divider class="-mx-6 text-border"></mat-divider>
  <div fxLayoutAlign="end center" class="py-2">
     <button
      matRipple
      type="button"
      mat-raised-button
      color="warn"
      (click)="onConfirm(false)"
    >
      Cancel Deployment
    </button>
    <button
      matRipple
      type="button"
      mat-raised-button
      class="bg-green text-contrast-white ml-2"
      (click)="onConfirm(true)"
    >
      Keep Deployment
    </button>
  </div>
</div>
